export const REQUEST_BOOKED_ENTERTAINMENTS = 'REQUEST_BOOKED_ENTERTAINMENTS';
export const RECEIVE_BOOKED_ENTERTAINMENTS = 'RECEIVE_BOOKED_ENTERTAINMENTS';
export const SET_BOOKED_ENTERTAINMENTS_FAILURE = 'SET_BOOKED_ENTERTAINMENTS_FAILURE';
export const CLEAR_BOOKED_ENTERTAINMENTS_ERROR_MESSAGE = 'CLEAR_BOOKED_ENTERTAINMENTS_ERROR_MESSAGE';
export const SET_SELECTED_NUM_OF_GUESTS = 'SET_SELECTED_NUM_OF_GUESTS';
